import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { onValueChange, displayNameOptionChange, clearDonorAdditionalInfo } from '../reducer';

import get from "lodash.get";
import * as validationHelper from "../../../helpers/validationHelper";

import { Form, Checkbox } from 'semantic-ui-react';
import DropdownField from '../../../components/common/formElements/dropdownField';
import TextAreaField from '../../../components/common/formElements/textAreaField';
import CInputField from '../../../components/common/formElements/cInputField';
import EmailField from '../../../components/common/formElements/emailField';
import FormbuilderAnswers from '../../../components/common/formbuilderAnswers';
import CheckboxField from '../../../components/common/formElements/checkboxField';

import { paths, fieldsValidation } from '../constants';
import { displayNameOptions, displayNameKeys } from '../../../constants/displayNameOptions';
import { salutationOptions } from '../../../constants/salutation';
import { tabs } from '../constants/tabs';
import { CampaignTypes } from '../../../constants/campaignTypes';
import { MAX_NAME_LENGTH } from '../../../constants/index';

class DetailsTabContainer extends React.Component {
    componentDidMount() {
        this.validate();
    }

    componentDidUpdate() {
        this.validate();
    }

    onChange = (path, value) => {
        this.props.onValueChange(path, value);
    }

    getValidationModels = (props) => {
        const allFields = fieldsValidation;

        const validationModels = Object.keys(allFields).map(item => {
            const validation = allFields[item];
            return {
                validationModel: validation,
                value: get(props.donation, validation.path)
            }
        });

        return validationModels;
    }

    validate = () => {
        const validationModels = this.getValidationModels(this.props);
        const billingSalutation = this.props.showSalutation && !this.props.isSalutationOptional ? !!get(this.props.donation, paths.SALUTATION) : true;

        const isAllFieldsValid = validationHelper.isAllFieldsValid(validationModels) && billingSalutation;

        if (this.props.isTabValid !== isAllFieldsValid) {
            this.onChange(paths.IS_DETAILS_TAB_VALID, isAllFieldsValid);
        }
    };

    leaveSupportMessageChange = (event, { checked }) => {
        this.props.clearDonorAdditionalInfo();
        this.props.onValueChange(paths.LEAVE_SUPPORT_MESSAGE, checked);
    };

    displayNameOptionChange = (event, { value }) => {
        this.props.displayNameOptionChange(value);
        this.props.onValueChange(paths.DISPLAY_NAME, null);
    };

    getDisplayNameOptions = () => {
        return displayNameOptions.map(x => {
            return {
                key: x.key,
                text: I18n.t(`donor.displayName.options.${x.translation}`) ,
                value: x.value
            };
        });
    };

    handleChange = (path, event, { value }) => {
        this.props.onValueChange(path, value);
    };

    onFormbuilderAnswersChange = (value) => {
        this.props.onValueChange(paths.FORMBUILDER_ANSWERS, value);
    }

    onBehalfOfCompanyChange = (value) => {
        this.props.onValueChange(paths.IS_BEHALF_OF_COMPANY, value)
        if (!value) {
            this.props.onValueChange(paths.BUSINESS_NAME, null)
        }
    }

    render() {
        const isDonationMessageOfSupportVisible = this.props.campaignType !== CampaignTypes.giveNow;
        const isDonationDisplayNameVisible = this.props.campaignType !== CampaignTypes.giveNow;

        const { customer, selectedDisplayNameOption, leaveSupportMessage, message, displayName, formbuilderAnswers } = this.props.donation;
        const { firstName, lastName, email, businessName, newsletter, isBehalfOfCompany, salutation } = customer;

        const salutationValidation = { required: this.props.isSalutationOptional ? false : true };

        const hideNewsLetterCheckbox = this.props.newsletter && this.props.newsletter.hide && this.props.newsletter.pages.some(item => item === "donation");
        return (
            <div className="user-stats-cont">
                <Form>
                    {
                        this.props.showSalutation &&
                        <DropdownField
                            label="Salutation"
                            id="Salutation"
                            value={salutation}
                            options={salutationOptions}
                            onChange={(event, { value }) => this.onChange(paths.SALUTATION, value)}
                            validation={salutationValidation} />
                    }

                    <CInputField label="First name"
                        id="firstName"
                        value={firstName}
                        onChange={(event, { value }) => this.onChange(paths.FIRST_NAME, value)}
                        validation={fieldsValidation.FIRST_NAME} />

                    <CInputField label="Last name"
                        id="lastName"
                        value={lastName}
                        validation={fieldsValidation.LAST_NAME}
                        onChange={(event, { value }) => this.onChange(paths.LAST_NAME, value)} />

                    <EmailField value={email}
                        label="Email"
                        id="email"
                        validation={fieldsValidation.EMAIL}
                        onChange={(value) => this.onChange(paths.EMAIL, value)} />

                    <FormbuilderAnswers
                        value={formbuilderAnswers}
                        onChange={this.onFormbuilderAnswersChange} />


                    <Form.Field>
                        <Checkbox checked={isBehalfOfCompany}
                            onChange={(event, { checked }) => this.onBehalfOfCompanyChange(checked)}
                            label="I'm donating on behalf of a company" />
                    </Form.Field>

                    <CInputField label="Company name"
                        value={businessName}
                        hidden={!isBehalfOfCompany}
                        validation={fieldsValidation.BUSINESS_NAME}
                        onChange={(event, { value }) => this.onChange(paths.BUSINESS_NAME, value)}
                    />
                    <Form.Field>
                        <Checkbox
                            checked={leaveSupportMessage}
                            label="Leave a support message"
                            onChange={this.leaveSupportMessageChange}
                        />
                    </Form.Field>
                    {
                        leaveSupportMessage &&
                        <React.Fragment>
                            {
                                isDonationMessageOfSupportVisible &&
                                <Form.Field>
                                    <label className="optional">Message of support</label>
                                    <TextAreaField value={message}
                                        validation={fieldsValidation.MESSAGE}
                                        onChange={(event, { value }) => this.onChange(paths.MESSAGE, value)} />
                                </Form.Field>
                            }
                            {
                                isDonationDisplayNameVisible &&
                                <React.Fragment>
                                    <Form.Field>
                                        <DropdownField
                                            label="Display name of message"
                                            options={this.getDisplayNameOptions()}
                                            value={selectedDisplayNameOption}
                                            onChange={this.displayNameOptionChange}
                                        />
                                    </Form.Field>
                                    {
                                        selectedDisplayNameOption === displayNameKeys.asCustomName &&
                                        <CInputField
                                            label="Custom name"
                                            value={displayName}
                                            onChange={this.handleChange.bind(this, paths.DISPLAY_NAME)}
                                            maxLength={MAX_NAME_LENGTH}
                                            validation={{ required: true }}
                                        />
                                    }
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                    {
                        !hideNewsLetterCheckbox &&
                        <CheckboxField
                            inputLabel={`I'd like to receive updates from ${this.props.organizationName}`}
                            checked={newsletter}
                            onChange={(event, { checked }) => this.onChange(paths.RECEIVE_NEWS_LETTER, checked)}
                        />
                    }

                </Form>
            </div>
        );
    }
};

const mapState = state => {
    return {
        donation: state.donation,
        isTabValid: state.donation.tabsValidation[tabs.DETAILS],

        organizationName: get(state, 'page.campaign.organization.name'),
        campaignType: get(state, 'page.campaign.type'),

        showSalutation: get(state, 'page.campaign.template.value.customSetup.showSalutation'),
        isSalutationOptional: get(state, 'page.campaign.template.value.customSetup.isSalutationOptional'),

        newsletter: get(state, "page.campaign.template.value.customSetup.newsletter")
    }
}

const mapDispatch = (dispatch) => {
    return {
        onValueChange(path, value) {
            dispatch(onValueChange(path, value))
        },
        clearDonorAdditionalInfo() {
            dispatch(clearDonorAdditionalInfo());
        },
        displayNameOptionChange(value) {
            dispatch(displayNameOptionChange(value));
        },
    }
}

const DetailsTab = connect(mapState, mapDispatch)(DetailsTabContainer);
export default DetailsTab;
